var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9974 1.04175C14.9416 1.04175 18.9557 5.05591 18.9557 10.0001C18.9557 14.9442 14.9416 18.9584 9.9974 18.9584C5.05323 18.9584 1.03906 14.9442 1.03906 10.0001C1.03906 5.05591 5.05323 1.04175 9.9974 1.04175ZM9.9974 2.29175C5.74323 2.29175 2.28906 5.74591 2.28906 10.0001C2.28906 14.2542 5.74323 17.7084 9.9974 17.7084C14.2516 17.7084 17.7057 14.2542 17.7057 10.0001C17.7057 5.74591 14.2516 2.29175 9.9974 2.29175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51958 13.3585C7.27625 13.6027 6.87958 13.6027 6.63625 13.3585C6.39208 13.1152 6.39208 12.7185 6.63625 12.4752L12.4696 6.64187C12.7129 6.3977 13.1096 6.3977 13.3529 6.64187C13.5971 6.8852 13.5971 7.28187 13.3529 7.5252L7.51958 13.3585Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3529 12.4752C13.5971 12.7185 13.5971 13.1152 13.3529 13.3585C13.1096 13.6027 12.7129 13.6027 12.4696 13.3585L6.63625 7.5252C6.39208 7.28187 6.39208 6.8852 6.63625 6.64187C6.87958 6.3977 7.27625 6.3977 7.51958 6.64187L13.3529 12.4752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.fd03d3c7cfa4d301d71ecd350bc59b37.svg";
export { ForwardRef as ReactComponent };